module.exports = __webpack_public_path__ + "static/media/Wsparcie_sprzedazy_2_A.e32d812c.png";